export default {
  title: 'Vorbestellung',
  categories: {
    title: 'Am beliebtesten',
  },
  header: {
    pickup: 'Abholung in 5 Minuten',
  },
};
